import angular from 'angular';

/**
 * Decorates the input directive with a `$focusing` flag,
 * much like the built-in flags `pristine`, `$dirty`, etc.
 */
export const FocusingHelper = angular
  .module('helpers.focusing', [])
  .directive('input', focusingDirective);

function focusingDirective($timeout) {
  return {
    require: '?ngModel',
    link: function(scope, element, attrs, ngModelCtrl) {
      if (ngModelCtrl) {
        element.on('focus', () => setFocus(true));
        element.on('blur', () => setFocus(false));
      }

      function setFocus(val) {
        $timeout(() => (ngModelCtrl.$focusing = val));
      }
    },
  };
}
